{"rating":"4.9","reviewCount":"140","fetchedAt":"2026-10-15T21:14:28.468Z","source":"place-details"}